import { useSyncExternalStore } from "react";

/** A CSS media query as React state (true on the server / first paint, like a desktop). */
export function useMedia(query: string): boolean {
	return useSyncExternalStore(
		(cb) => {
			const mq = window.matchMedia(query);
			mq.addEventListener("change", cb);
			return () => mq.removeEventListener("change", cb);
		},
		() => window.matchMedia(query).matches,
		() => true,
	);
}
